import InvoiceModel from '../Apis/Invoice'
import Controller from './Controller'

export default class InvoiceController extends Controller {
  constructor() {
    super(new InvoiceModel())
  }
}
